import axios from "axios";
import store from "store";
import { SET_ERROR } from "slices/globalError.slice";
import { SET_TOKEN } from "slices/global.slice";

export default (isAppInMaintenance?: boolean) => {
  const corsHeaders = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "x-maintenance-mode": isAppInMaintenance,
  };

  const headers = { ...corsHeaders };
  //axios.defaults.baseURL = 'https://api.caladre.com/';
  axios.defaults.baseURL = process.env.REACT_APP_API_URL?.trim() ?? "";
  axios.defaults.headers = {
    ...axios.defaults.headers,
    ...headers,
  } as any;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const serializedError = {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      };

      store.dispatch(SET_ERROR(serializedError));

      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token is invalid or expired
        localStorage.removeItem("token");
        store.dispatch(SET_TOKEN(null));
        // Redirect to the authentication page
        if (false && window.location.pathname !== "/auth")
          window.location.href = "/auth";
      }

      return Promise.reject(error);
    },
  );
};
